import React, { ReactElement } from 'react';
import { ThumbBasic as Thumbnail } from './ThumbBasic';

export interface ThumbsSelectListProps {
  options: {
    illustration: ReactElement;
    value: any;
  }[];
  keyId?: string;
  value?: any[];
  noselect?: boolean;
  multiselect?: boolean;
  layout?: {
    itemWidth: string;
    itemHeight: string;
    gap: string;
    itemsPerLine: number;
  };
  onChange?: (value: string[]) => void;
  disabled?: boolean;
}

export const ThumbsSelectList: React.FC<ThumbsSelectListProps> = ({
  options = [],
  value = [],
  noselect = false,
  multiselect = false,
  keyId = 'thumb_select_list',
  layout = {
    itemWidth: '28px',
    itemHeight: '28px',
    gap: '8px',
    itemsPerLine: 6,
  },
  onChange,
  disabled,
}) => {
  const [selected, _setSelected] = React.useState<string[]>(value);

  const setSelected = React.useCallback(
    (_value: string) =>
      _setSelected((selectedList) => {
        const isSelected = selectedList.includes(_value);
        let newValue;
        if (!isSelected) {
          // Add scenario - if multiselect, keep array, else keep array of one
          newValue = multiselect ? [...selectedList, _value] : [_value];
        } else {
          // Remove scenario - if one and no select is not allowed keep last value, else remove
          newValue =
            selectedList.length === 1 && !noselect
              ? [_value]
              : selectedList.filter((v) => v !== _value);
        }
        onChange?.(newValue);
        return newValue;
      }),
    [multiselect, noselect, onChange],
  );

  const elements = options.map(({ illustration, value: _value }, i) => (
    <Thumbnail
      key={`${keyId}_${i}`}
      onClick={() => !disabled && setSelected(_value)}
      value={_value}
      illustration={illustration}
      className={
        disabled ? 'disabled' : selected.includes(_value) ? 'selected' : ''
      }
    />
  ));
  return (
    <div
      style={{
        height: layout.itemHeight,
        display: 'grid',
        gridTemplateColumns: `repeat(${layout.itemsPerLine}, ${layout.itemWidth})`,
        gap: layout.gap,
      }}
    >
      {elements}
    </div>
  );
};
